"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _moment = _interopRequireDefault(require("moment"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _startCase = _interopRequireDefault(require("lodash/startCase"));

var _typography = _interopRequireDefault(require("britive-design-system/core/components/typography"));

var _constants = require("./constants");

var _commonUtils = require("../../../../utils/common-utils");

var _constant = require("../../../timezone-selector/constant");

var _lodash = require("lodash");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var styles = "/* Add custom scrollbar style for Chrome, Safari, FF and Edge */\n.generic-condition-header-class .header-class {\n  margin-top: 2rem;\n  padding-bottom: 0.5rem;\n  border-bottom: 1px solid #a8a8a8; }\n  .generic-condition-header-class .header-class .margin-top-32 {\n    margin-top: 2rem; }\n  .generic-condition-header-class .header-class .margin-top-8 {\n    margin-top: 0.5rem; }\n";
  var fileName = "compone_GenericConditions";
  var element = document.querySelector("style[data-sass-component='compone_GenericConditions']");

  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();

function PolicyGenericConditions(_ref) {
  var _conditionJSON$timeOf, _conditionJSON$timeOf2, _policyViewData$condi;

  var _ref$policyViewData = _ref.policyViewData,
      policyViewData = _ref$policyViewData === void 0 ? {} : _ref$policyViewData,
      translatedStrings = _ref.translatedStrings,
      conditionsLabels = _ref.conditionsLabels,
      viewPolicyHeaders = _ref.viewPolicyHeaders;

  var _ref2 = policyViewData !== null && policyViewData !== void 0 ? policyViewData : {},
      condition = _ref2.condition;

  var conditionJSON = !(0, _lodash.isEmpty)(condition) ? condition : null;
  var isDateTime = !!(conditionJSON !== null && conditionJSON !== void 0 && conditionJSON.timeOfAccess);
  var dateSchedule = conditionJSON === null || conditionJSON === void 0 ? void 0 : (_conditionJSON$timeOf = conditionJSON.timeOfAccess) === null || _conditionJSON$timeOf === void 0 ? void 0 : _conditionJSON$timeOf.dateSchedule;
  var daysSchedule = conditionJSON === null || conditionJSON === void 0 ? void 0 : (_conditionJSON$timeOf2 = conditionJSON.timeOfAccess) === null || _conditionJSON$timeOf2 === void 0 ? void 0 : _conditionJSON$timeOf2.daysSchedule;
  var selectedTimezone = (dateSchedule === null || dateSchedule === void 0 ? void 0 : dateSchedule.timezone) || (daysSchedule === null || daysSchedule === void 0 ? void 0 : daysSchedule.timezone);
  var timezone = selectedTimezone ? _constant.timezones.find(function (t) {
    return t.value === selectedTimezone;
  }).utc : null;

  var getDateSchedule = function getDateSchedule() {
    if (isDateTime && dateSchedule) {
      return "From ".concat((0, _moment.default)(dateSchedule.fromDate).format("MM/DD/yyyy hh:mm A"), " ").concat(timezone, " \n        to ").concat((0, _moment.default)(dateSchedule.toDate).format("MM/DD/yyyy hh:mm A"), " ").concat(timezone);
    } else {
      return 'None';
    }
  };

  var getDaysSchedule = function getDaysSchedule() {
    if (isDateTime && daysSchedule) {
      return "Available from ".concat((0, _moment.default)(daysSchedule.fromTime, ['h:m']).format("hh:mm A"), " ").concat(timezone, " \n        to ").concat((0, _moment.default)(daysSchedule.toTime, ['h:m']).format("hh:mm A"), " ").concat(timezone, " \n        on every ").concat((0, _commonUtils.getDaysString)(daysSchedule.days.map(function (day) {
        return (0, _startCase.default)(day.toLowerCase());
      })));
    } else {
      return 'None';
    }
  };

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.container
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.headerClass
  }, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "pageSectionHeader"
  }, " ", viewPolicyHeaders === null || viewPolicyHeaders === void 0 ? void 0 : viewPolicyHeaders.generic, " ")), /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.marginTop32
  }, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "label2"
  }, " ", conditionsLabels === null || conditionsLabels === void 0 ? void 0 : conditionsLabels.ip, " "), /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.marginTop8
  }, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "label1"
  }, !(0, _lodash.isEmpty)(policyViewData === null || policyViewData === void 0 ? void 0 : policyViewData.condition) && (policyViewData === null || policyViewData === void 0 ? void 0 : (_policyViewData$condi = policyViewData.condition) === null || _policyViewData$condi === void 0 ? void 0 : _policyViewData$condi.ipAddress) || (translatedStrings === null || translatedStrings === void 0 ? void 0 : translatedStrings.noneText)))), /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.marginTop32
  }, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "label2"
  }, " ", translatedStrings.startAndEndDateTime, " "), /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.marginTop8
  }, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "label1"
  }, getDateSchedule() || translatedStrings.noneText))), /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.marginTop32
  }, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "label2"
  }, " ", translatedStrings.dateTimeSchedule, " "), /*#__PURE__*/_react.default.createElement("div", {
    className: _constants.classes.marginTop8
  }, /*#__PURE__*/_react.default.createElement(_typography.default, {
    variant: "label1"
  }, getDaysSchedule() || translatedStrings.noneText)))));
}

PolicyGenericConditions.propTypes = {
  policyViewData: _propTypes.default.object,
  translatedStrings: _propTypes.default.object,
  conditionsLabels: _propTypes.default.shape({
    ip: _propTypes.default.string,
    startTime: _propTypes.default.string,
    endTime: _propTypes.default.string,
    startDate: _propTypes.default.string,
    endDate: _propTypes.default.string
  }),
  viewPolicyHeaders: _propTypes.default.shape({
    general: _propTypes.default.string,
    members: _propTypes.default.string,
    generic: _propTypes.default.string,
    approvals: _propTypes.default.string
  })
};
var _default = PolicyGenericConditions;
exports.default = _default;